import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { UploadButtonProps } from '../types';

const UploadButton = memo(({ onClick }: UploadButtonProps) => (
	<Box
		sx={{
			border          : '1px dashed #24a4c4',
			backgroundColor : '#F7FCFD',
			padding         : 2,
			textAlign       : 'center',
			borderRadius    : 2,
			cursor          : 'pointer',
			display         : 'flex',
			justifyContent  : 'center',
			my              : 3
		}}
		onClick={onClick}
	>
		<Typography fontSize={16} display={'flex'} color='#737373' alignItems={'center'}>
			<AddIcon fontSize='large' sx={{ color: '#737373' }}/>&nbsp;Set thumbnail
		</Typography>
	</Box>
));

UploadButton.displayName = 'UploadButton';
export default UploadButton;